import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxMaskModule } from 'ngx-mask';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { RouterModule, Router } from "@angular/router";

//import * as $ from "jquery"; //do not remove unless jQuery dependency used by froala is removed!
import { OwlDateTimeModule, OwlNativeDateTimeModule } from "@danielmoncada/angular-datetime-picker";
import { OAuthModule } from 'angular-oauth2-oidc';
import { FullCalendarModule } from "@fullcalendar/angular";
import { AuthModule } from "./auth/auth.module";
import { LawLibraryModule } from './law-library/law-library.module';
import { HelpLibraryModule } from './help-library/help-library.module';
import { GisModule } from "./gis/gis.module";
import { LunaPaymentsModule } from "./payments/payments.module";
import { EntityBuilderModule } from "./entity-builder/entity-builder.module";
import { AuthService } from "./services/auth.service";
import { AppComponent } from "./app.component";
import { ScrollContentComponent } from "./layouts/scroll-content.component";
import { AuthInterceptor } from "./services/auth.interceptor";
import { AppRoutingModule } from './app-routing.module';
import { LunaBuilderModule } from "./builder/builder.module";
import { LunaCommonModule } from "./common/common.module";
import { LunaCoreModule } from "./core/core.module";
import { LunaDashboardModule } from "./dashboard/dashboard.module";
import { LunaFlowModule } from "./flow/flow.module";
import { LunaAdminModule } from "./admin/admin.module";
import { LayoutService } from "./layouts/services/layout.service";
import { EventsService } from './services/events.service';
import { ReportsModule } from './reports/reports.module';
import { ReportLayoutComponent } from './layouts/report-layout.component';
import { HttpNoCacheInterceptor } from './interceptors/IE-HTTP-no-cache.interceptor';
import { LettersModule} from "./letters/letters.module";
import { TextTemplatesModule} from "./text-templates/text-templates.module";
import { DomainDefinitionService} from "./builder/services/domain-definition.service";
//import { ModuleRegistry, AllModules } from '@ag-grid-enterprise/all-modules';
import { AllCommunityModule, ClientSideRowModelModule } from "ag-grid-community";
import { FiltersToolPanelModule } from "ag-grid-enterprise";
import { SetFilterModule } from "ag-grid-enterprise";
import { ColumnsToolPanelModule } from "ag-grid-enterprise";
import {
    GroupFilterModule,
    PivotModule,
    RowGroupingModule,
    RowGroupingPanelModule,
    TreeDataModule,
} from "ag-grid-enterprise";
import { StatusBarModule } from "ag-grid-enterprise";
import { ExcelExportModule } from "ag-grid-enterprise";
import { RichSelectModule } from "ag-grid-enterprise";
import { CsvExportModule, ModuleRegistry } from "ag-grid-community";
import { ApplicationsModule } from "./applications/applications.module";
// TESTING/DEMO
import { PaymentResponseComponent } from "./payments/components/payment-response/payment-response.component";
import { HomeGuard } from './core/components/guards/home.guard';
import { OrganizationModule } from './common/components/organization/organization.module';
import { NavResolver } from './core/components/resolvers/nav.resolver';
import { ChiefsOrderService } from './services/chiefsOrder.service';
import { PostDrillingModule } from "./post-drilling/post-drilling.module";
import { OnBehalfModule } from "./on-behalf/on-behalf.module";
 
export const HttpInterceptorProviders = [
     { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpNoCacheInterceptor, multi: true } 
];

@NgModule({ bootstrap: [AppComponent],
    declarations: [
        AppComponent,
        ScrollContentComponent,
        ReportLayoutComponent
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule
    ], imports: [AppRoutingModule,
        AuthModule,
        OrganizationModule,
        BrowserAnimationsModule,
        BrowserModule,
        CommonModule,
        FormsModule,
        GisModule,
        LunaPaymentsModule,
        EntityBuilderModule,
        HelpLibraryModule,
        LunaCommonModule,
        LunaCoreModule,
        LunaDashboardModule,
        LunaFlowModule,
        LawLibraryModule,
        LunaBuilderModule,
        LunaAdminModule,
        LettersModule,
        ReactiveFormsModule,
        ReportsModule,
        TextTemplatesModule,
        OAuthModule.forRoot(),
        NgxMaskModule.forRoot(),
        FullCalendarModule,
        PostDrillingModule,
        ApplicationsModule,
        OnBehalfModule], providers: [
        EventsService,
        HomeGuard,
        AuthService,
        NavResolver,
        LayoutService,
        Title,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        HttpInterceptorProviders,
        DomainDefinitionService,
        ChiefsOrderService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {
    constructor(private readonly router: Router) {
		//ModuleRegistry.registerModules(AllModules);
		ModuleRegistry.registerModules([
            RowGroupingModule,
            RowGroupingPanelModule,
            GroupFilterModule,
            TreeDataModule,
            PivotModule,
            ClientSideRowModelModule,
            AllCommunityModule,
            FiltersToolPanelModule,
            SetFilterModule,
            ColumnsToolPanelModule,
            StatusBarModule,
            ExcelExportModule,
            CsvExportModule,
            RichSelectModule
        ]);
        //router.events.subscribe(console.log);
    }
}
